import { createSlice } from "@reduxjs/toolkit";
import { AddSSD, UpdateSSD, GetSSDList } from "services/other/ssd.service";
import { toast } from 'react-toastify';

export const ssdAddSlice = createSlice({
  name: "ssdAdd",
  initialState: {
    ssdAdd: {},
    ssdAddLoading: false,
    ssdAddError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(AddSSD.pending, (state) => {
      // toast.loading('We are adding the ssd 🤯')
      state.ssdAddLoading = true
    });

    builder.addCase(AddSSD.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('New ssd added successfully 👌');

      state.ssdAdd = action.payload
      state.ssdAddLoading = false
      state.ssdAddError = null
    });

    builder.addCase(AddSSD.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the ssd 😣")

      state.ssdAddLoading = false
      state.ssdAddError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const ssdUpdateSlice = createSlice({
  name: "ssdUpdate",
  initialState: {
    ssdUpdate: {},
    ssdUpdateLoading: false,
    ssdUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateSSD.pending, (state) => {
      // toast.loading('We are updating the ssd 🤯')
      state.ssdUpdateLoading = true
    });

    builder.addCase(UpdateSSD.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Category update successfully 👌');

      state.ssdUpdate = action.payload
      state.ssdUpdateLoading = false
      state.ssdUpdateError = null
    });

    builder.addCase(UpdateSSD.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update the ssd 😣")

      state.ssdUpdateLoading = false
      state.ssdUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});



export const ssdListSlice = createSlice({
  name: "ssdList",
  initialState: {
    ssdList: [],
    ssdListLoading: false,
    ssdListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetSSDList.pending, (state) => {
      state.ssdListLoading = true
    });

    builder.addCase(GetSSDList.fulfilled, (state, action) => {
      toast.dismiss();

      state.ssdList = action.payload
      state.ssdListLoading = false
      state.ssdListError = null
    });

    builder.addCase(GetSSDList.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the ssd 😣")

      state.ssdListLoading = false
      state.ssdListError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});